import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import { faSortDown, faSortUp } from "@fortawesome/pro-duotone-svg-icons";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { SORT_BY_MAP, SORT_ORDER_MAP } from "../../types/sort";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import AwesomeIcon from "../AwesomeIcon";
import DropdownMenu from "../common/DropdownMenu";
import Tooltip from "../common/Tooltip";
var DropdownOption = function DropdownOption(_ref) {
  var selectedType = _ref.selectedType,
    type = _ref.type,
    label = _ref.label,
    icon = _ref.icon,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center gap-3 py-2 px-3", {
      "opacity-40": disabled
    })
  }, selectedType === type ? /*#__PURE__*/React.createElement(AwesomeIcon, {
    size: "xs",
    name: faCheck
  }) : /*#__PURE__*/React.createElement("div", {
    className: "w-[11px]"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-md font-medium capitalize"
  }, label), /*#__PURE__*/React.createElement("span", {
    className: "text-md ml-auto"
  }, icon));
};

/**
 * A reusable sort control component with dropdown for column selection and sort order.
 * Supports sorting by different timestamp columns (Last updated, Date created).
 */
var SortControl = function SortControl(_ref2) {
  var _ref2$isFullWidthWork = _ref2.isFullWidthWorklist,
    isFullWidthWorklist = _ref2$isFullWidthWork === void 0 ? false : _ref2$isFullWidthWork,
    _ref2$sortControlActi = _ref2.sortControlActive,
    sortControlActive = _ref2$sortControlActi === void 0 ? false : _ref2$sortControlActi,
    selectedType = _ref2.selectedType,
    onTypeChange = _ref2.onTypeChange,
    sortOrder = _ref2.sortOrder,
    onSortChange = _ref2.onSortChange,
    onSortParamsChange = _ref2.onSortParamsChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isReminderSortOnShortWorklist = selectedType === SORT_BY_MAP.reminder && sortControlActive;
  var isReminderSortOnFullWorklist = selectedType === SORT_BY_MAP.reminder && isFullWidthWorklist;
  var sortByOptions = [{
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: selectedType,
      type: SORT_BY_MAP.updated_at,
      label: t("last_updated")
    }),
    label: t("last_updated"),
    type: SORT_BY_MAP.updated_at,
    onClick: function onClick() {
      if (selectedType !== SORT_BY_MAP.updated_at) {
        onSortParamsChange({
          orderBy: SORT_BY_MAP.updated_at,
          order: SORT_ORDER_MAP.desc
        });
      }
      trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_TYPE_CHANGED, {
        label: SORT_BY_MAP.updated_at
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: selectedType,
      type: SORT_BY_MAP.created_at,
      label: t("date_created")
    }),
    type: SORT_BY_MAP.created_at,
    label: t("date_created"),
    onClick: function onClick() {
      if (selectedType !== SORT_BY_MAP.created_at) {
        onSortParamsChange({
          orderBy: SORT_BY_MAP.created_at,
          order: SORT_ORDER_MAP.desc
        });
      }
      trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_TYPE_CHANGED, {
        label: SORT_BY_MAP.created_at
      });
    }
  }, {
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: selectedType,
      type: SORT_BY_MAP.reminder,
      label: t("label.task_due"),
      icon: isReminderSortOnShortWorklist ? /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faSortUp,
        className: "w-4 h-4"
      }) : null
    }),
    type: SORT_BY_MAP.reminder,
    label: t("label.task_due"),
    onClick: function onClick() {
      onSortParamsChange({
        orderBy: SORT_BY_MAP.reminder,
        order: SORT_ORDER_MAP.asc
      });
      trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_TYPE_CHANGED, {
        label: SORT_BY_MAP.reminder
      });
    }
  }];
  var sortOrderOptions = [{
    type: SORT_ORDER_MAP.asc,
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: sortControlActive ? sortOrder || "" : "",
      label: t("key.oldest_to_newest"),
      type: SORT_ORDER_MAP.asc,
      icon: /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faSortUp,
        className: "w-4 h-4"
      })
    }),
    label: t("key.oldest_to_newest"),
    onClick: function onClick() {
      onSortChange(SORT_ORDER_MAP.asc);
      trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_ORDER_CHANGED, {
        label: SORT_ORDER_MAP.asc
      });
    }
  }, {
    type: SORT_ORDER_MAP.desc,
    name: /*#__PURE__*/React.createElement(DropdownOption, {
      selectedType: sortControlActive ? sortOrder || "" : "",
      type: SORT_ORDER_MAP.desc,
      label: t("key.newest_to_oldest"),
      icon: /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faSortDown,
        className: "w-4 h-4"
      }),
      disabled: isReminderSortOnShortWorklist
    }),
    label: t("key.newest_to_oldest"),
    className: isReminderSortOnShortWorklist ? "!cursor-not-allowed pointer-events-none" : undefined,
    onClick: isReminderSortOnShortWorklist ? function () {} : function () {
      onSortChange(SORT_ORDER_MAP.desc);
      trackEvent(MIXPANEL_EVENTS.WORKLIST_SORT_ORDER_CHANGED, {
        label: SORT_ORDER_MAP.desc
      });
    }
  }];
  var divider = {
    name: /*#__PURE__*/React.createElement("div", {
      className: "my-2 border-t border-gray-300 dark:border-gray-600"
    }),
    onClick: function onClick() {},
    className: "!p-0 !hover:bg-transparent cursor-default"
  };
  var options = [].concat(_toConsumableArray(sortByOptions.filter(function (item) {
    return isFullWidthWorklist ? item.type !== SORT_BY_MAP.reminder : true;
  })), _toConsumableArray(isReminderSortOnShortWorklist ? [] : [divider].concat(sortOrderOptions)));
  var selectedOption = sortByOptions.find(function (opt) {
    return opt.type === selectedType;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, isFullWidthWorklist && /*#__PURE__*/React.createElement("span", null, t("patient_info")), !isReminderSortOnFullWorklist && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: options,
    menuItemClassName: "!left-0 !right-auto !w-40",
    buttonClassName: "dark:hover:bg-transparent",
    hasCustomControl: true,
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("span", {
        className: "flex items-center gap-2 text-gray-600 dark:text-gray-500 text-[10px] italic"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-normal  px-[8px] py-[1px] rounded-xl ".concat(sortControlActive ? "bg-teal-500/12" : "")
      }, sortControlActive ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label : ""), /*#__PURE__*/React.createElement(Tooltip, {
        className: "[&_.tooltip-content]:text-sm [&_.tooltip-content]:capitalize [&_.tooltip-content]:rounded-6 [&_.tooltip-content]:py-2 [&_.tooltip-content]:px-3 [&_.tooltip-content]:text-gray-100",
        tooltipText: "".concat(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, " - ").concat((sortOrder === SORT_ORDER_MAP.asc ? t("key.oldest_to_newest") : t("key.newest_to_oldest")).toUpperCase())
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: sortOrder === SORT_ORDER_MAP.asc ? faSortUp : faSortDown,
        className: "w-4 h-4 text-gray-600 dark:text-gray-200"
      })));
    }
  }));
};
export default SortControl;

// Re-export types for convenience
export { SORT_BY_MAP, SORT_ORDER_MAP } from "../../types/sort";